const translations = {
  "sidebar.mainPage": "Home",
};

export default translations;
